import axiosIns from "@/api/axios";

const cleanPayload = (data = {}) => Object.fromEntries(
  Object.entries(data || {}).filter(([, value]) => value !== null && value !== undefined && value !== "")
);

export const PROFILE = () => {
  return axiosIns.get("/users/identify");
};

export const GET_LIST_USER_BY_FILTERS = (data) => {
  const url = "/users/employee-filters";

  return axiosIns.post(url, cleanPayload(data));
};

export const GET_ROLE_MANAGEMENT_USERS = (params) => {
  return axiosIns.get("/users/role-management", { params: cleanPayload(params) });
};

export const GET_ROLE_MANAGEMENT_ROLES = () => {
  return axiosIns.get("/users/role-management/roles");
};

export const UPDATE_ROLE_MANAGEMENT_USER = ({ id, role_id }) => {
  return axiosIns.put(`/users/role-management/${id}`, { role_id });
};
